class NotificationsService {
    constructor($mdToast) {
        this.$mdToast = $mdToast;
    }

    show(message, theme) {
        this.$mdToast.show(
            this.$mdToast.simple()
            .textContent(message)
            .position("bottom right")
            .hideDelay(6000)
            .theme(theme + "-toast")
        );
    }
}

export default NotificationsService;


// WEBPACK FOOTER //
// ./src/js/services/notifications.service.js